// extracted by mini-css-extract-plugin
export var modalFooter = "_me-0";